<table class="table">
    <thead>
        <tr>
            <th>
                <p class="m-0 text-center">LoB</p>
            </th>
            <th *ngFor="let mes of meses">
                <p class="m-0 text-center">{{ mes.nameShort }}</p>
            </th>
        </tr>
    </thead>
    <tbody>
        <tr>
            <td style="width: 450px">
                <div class="row px-1">
                    <div class="col-2 custom-center">
                        <button class="btn btn-danger p-0 m-0 custom-center" style="border-radius: 9999px"
                            (click)="onDelete()">
                            <i class="pi pi-trash m-1"></i>
                        </button>
                    </div>
                    <div class="col-10">
                        <p-dropdown appendTo="body" [options]="lobs" [(ngModel)]="lob.selectedLob" optionLabel="name"
                            [style]="{ width: '100%' }" [ngClass]="{ error: hasError && !lob.selectedLob }"
                            (ngModelChange)="setSectors()" placeholder="Seleccione una LoB" />
                    </div>

                    <div class="hide-container" [ngClass]="{ 'show-container': lob.selectedLob }">
                        <div>
                            <div class="col-12 text-center m-0 p-0">
                                <p class="add-text m-0" (click)="addSector()">Agregar sector +</p>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- {{ lob.lob }} <i *ngIf="lob.sector.length > 0" class="pi pi-sort-down-fill ml-2"></i> -->

                <div class="hide-container" [ngClass]="{ 'show-container': hasError && !lob.selectedLob }">
                    <div>
                        <p class="text-danger p-0 m-0 pt-2">Debe completar este campo.</p>
                    </div>
                </div>
            </td>
            <ng-container *ngIf="lob.sector.length === 0; else disabled">
                <td style="width: 150px" *ngFor="let cantidad of lob.cantidades; let i = index; trackBy: trackByIndex">
                    <input class="form-control text-center" type="number" [(ngModel)]="lob.cantidades[i]"
                        [attr.data-index]="i" />
                </td>
            </ng-container>
            <ng-template #disabled>
                <td style="width: 150px" *ngFor="let cantidad of lob.cantidades; let i = index; trackBy: trackByIndex">
                    <input class="form-control text-center" type="number" [(ngModel)]="lob.cantidades[i]"
                        [attr.data-index]="i" disabled="true" />
                </td>
            </ng-template>
        </tr>
        <ng-container *ngIf="lob.selectedLob">
            <tr *ngFor="let sector of lob.sector; let i = index">
                <!-- <td class="pl-5">{{ sector.nombre }}</td> -->
                <td class="pl-5">
                    <div class="row px-1">
                        <div class="col-2 custom-center">
                            <button class="btn btn-danger p-0 m-0 custom-center" style="border-radius: 9999px"
                                (click)="deleteSector(i); sumarCantidades()">
                                <i class="pi pi-trash m-1"></i>
                            </button>
                        </div>
                        <div class="col-10">
                            <p-dropdown appendTo="body" [options]="lob.selectedLob.sector"
                                [(ngModel)]="sector.selectedSector" optionLabel="name"
                                [ngClass]="{ error: hasError && !sector.selectedSector }" [style]="{ 'width': '100%' }"
                                (ngModelChange)="openModal(sector.selectedSector, i)"
                                placeholder="Seleccione un sector" />
                        </div>
                    </div>

                    <div class="hide-container" [ngClass]="{ 'show-container': hasError && !sector.selectedSector }">
                        <div>
                            <p class="text-danger p-0 m-0">Debe completar este campo.</p>
                        </div>
                    </div>

                </td>
                <td *ngFor="let cantidad of sector.cantidades; let i = index; trackBy: trackByIndex">
                    <input class="form-control text-center" type="number" [(ngModel)]="sector.cantidades[i]"
                        [attr.data-index]="i" (ngModelChange)="sumarCantidades()" />
                </td>

            </tr>
        </ng-container>
    </tbody>
</table>

<p-dialog [modal]="true" [draggable]="false" [style]="{ 'min-width': '60%' }" header="Ingrese nuevo sector"
    [(visible)]="visible" (onHide)="sectorI.value = ''; checkSector()">
    <label>Sector</label>
    <input type="text" pInputText [style]="{ width: '100%' }" #sectorI placeholder="Ingrese nombre del sector">
    <div class="hide-container" [ngClass]="{ 'show-container': error }">
        <div>
            <p class="text-danger">Debe ingresar un nombre para el sector</p>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <div class="row">
            <div class="col-12 text-end">
                <button class="btn btn-primary" (click)="setNewSector(sectorI.value)">
                    Cargar
                </button>
            </div>
        </div>
    </ng-template>
</p-dialog>